/**
 * Every icon in the app comes from Central Icons (iconists.co/central).
 * The style lives in the two package names below: change them to restyle all icons.
 */
import type { CentralIconBaseProps } from "@central-icons-react/round-outlined-radius-2-stroke-2";
import { forwardRef, type ComponentType, type RefAttributes } from "react";
import {
  IconAgents as OutlinedIconAgents,
  IconArchive as OutlinedIconArchive,
  IconArrowBoxLeft as OutlinedIconArrowBoxLeft,
  IconArrowCornerDownRight as OutlinedIconArrowCornerDownRight,
  IconArrowDown as OutlinedIconArrowDown,
  IconArrowInbox as OutlinedIconArrowInbox,
  IconArrowLeft as OutlinedIconArrowLeft,
  IconArrowOutOfBox as OutlinedIconArrowOutOfBox,
  IconArrowRight as OutlinedIconArrowRight,
  IconArrowRotateClockwise as OutlinedIconArrowRotateClockwise,
  IconArrowRotateCounterClockwise as OutlinedIconArrowRotateCounterClockwise,
  IconArrowShareLeft as OutlinedIconArrowShareLeft,
  IconArrowSplitRight as OutlinedIconArrowSplitRight,
  IconArrowUp as OutlinedIconArrowUp,
  IconArrowsHide as OutlinedIconArrowsHide,
  IconArrowsLeftRight as OutlinedIconArrowsLeftRight,
  IconArrowsRepeatRightLeft as OutlinedIconArrowsRepeatRightLeft,
  IconAudio as OutlinedIconAudio,
  IconBarsThree as OutlinedIconBarsThree,
  IconBell as OutlinedIconBell,
  IconBook as OutlinedIconBook,
  IconBrackets2 as OutlinedIconBrackets2,
  IconBrain as OutlinedIconBrain,
  IconBrain2 as OutlinedIconBrain2,
  IconBranch as OutlinedIconBranch,
  IconBrokenChainLink1 as OutlinedIconBrokenChainLink1,
  IconBroom as OutlinedIconBroom,
  IconBubble5 as OutlinedIconBubble5,
  IconBubbleText as OutlinedIconBubbleText,
  IconBubbles as OutlinedIconBubbles,
  IconBuildings as OutlinedIconBuildings,
  IconCalendar1 as OutlinedIconCalendar1,
  IconCall as OutlinedIconCall,
  IconCallCancel as OutlinedIconCallCancel,
  IconCallIncoming as OutlinedIconCallIncoming,
  IconCallOutgoing as OutlinedIconCallOutgoing,
  IconCamera1 as OutlinedIconCamera1,
  IconChainLink1 as OutlinedIconChainLink1,
  IconChart1 as OutlinedIconChart1,
  IconCheckCircle2 as OutlinedIconCheckCircle2,
  IconChecklist as OutlinedIconChecklist,
  IconCheckmark1 as OutlinedIconCheckmark1,
  IconChevronDoubleLeft as OutlinedIconChevronDoubleLeft,
  IconChevronDoubleRight as OutlinedIconChevronDoubleRight,
  IconChevronDownMedium as OutlinedIconChevronDownMedium,
  IconChevronGrabberVertical as OutlinedIconChevronGrabberVertical,
  IconChevronLeftMedium as OutlinedIconChevronLeftMedium,
  IconChevronRightMedium as OutlinedIconChevronRightMedium,
  IconChevronTopMedium as OutlinedIconChevronTopMedium,
  IconCircle as OutlinedIconCircle,
  IconCircleBanSign as OutlinedIconCircleBanSign,
  IconCircleInfo as OutlinedIconCircleInfo,
  IconCircleRecord as OutlinedIconCircleRecord,
  IconCircleX as OutlinedIconCircleX,
  IconClock as OutlinedIconClock,
  IconCmd as OutlinedIconCmd,
  IconCode as OutlinedIconCode,
  IconCoins as OutlinedIconCoins,
  IconConditionalLogic as OutlinedIconConditionalLogic,
  IconCreditCard1 as OutlinedIconCreditCard1,
  IconCrossMedium as OutlinedIconCrossMedium,
  IconDirection1 as OutlinedIconDirection1,
  IconDotGrid1x3Horizontal as OutlinedIconDotGrid1x3Horizontal,
  IconDotGrid2x3 as OutlinedIconDotGrid2x3,
  IconDotGrid3x3 as OutlinedIconDotGrid3x3,
  IconEditBig as OutlinedIconEditBig,
  IconElectrocardiogram as OutlinedIconElectrocardiogram,
  IconEmail1 as OutlinedIconEmail1,
  IconEmail3 as OutlinedIconEmail3,
  IconExclamationCircle as OutlinedIconExclamationCircle,
  IconExclamationTriangle as OutlinedIconExclamationTriangle,
  IconEyeOpen as OutlinedIconEyeOpen,
  IconEyeSlash as OutlinedIconEyeSlash,
  IconFileText as OutlinedIconFileText,
  IconFilter1 as OutlinedIconFilter1,
  IconFilterAscending as OutlinedIconFilterAscending,
  IconFilterDescending as OutlinedIconFilterDescending,
  IconFlag1 as OutlinedIconFlag1,
  IconFormSquare as OutlinedIconFormSquare,
  IconGlobe as OutlinedIconGlobe,
  IconGoogle as OutlinedIconGoogle,
  IconH1 as OutlinedIconH1,
  IconH2 as OutlinedIconH2,
  IconH3 as OutlinedIconH3,
  IconHashtag as OutlinedIconHashtag,
  IconHeadphones as OutlinedIconHeadphones,
  IconHistory as OutlinedIconHistory,
  IconHourglass as OutlinedIconHourglass,
  IconImages1 as OutlinedIconImages1,
  IconInboxEmpty as OutlinedIconInboxEmpty,
  IconLayersTwo as OutlinedIconLayersTwo,
  IconLightning as OutlinedIconLightning,
  IconLinkedin as OutlinedIconLinkedin,
  IconListAdd as OutlinedIconListAdd,
  IconListBullets as OutlinedIconListBullets,
  IconLoadingCircle as OutlinedIconLoadingCircle,
  IconLock as OutlinedIconLock,
  IconMagnifyingGlass as OutlinedIconMagnifyingGlass,
  IconMapPin as OutlinedIconMapPin,
  IconMegaphone as OutlinedIconMegaphone,
  IconMicrophone as OutlinedIconMicrophone,
  IconMicrophoneOff as OutlinedIconMicrophoneOff,
  IconMinusMedium as OutlinedIconMinusMedium,
  IconMoon as OutlinedIconMoon,
  IconNotepad as OutlinedIconNotepad,
  IconNumberedList as OutlinedIconNumberedList,
  IconOpenQuote1 as OutlinedIconOpenQuote1,
  IconPageEmpty as OutlinedIconPageEmpty,
  IconPaperPlane as OutlinedIconPaperPlane,
  IconPaperPlaneTopRight as OutlinedIconPaperPlaneTopRight,
  IconPaperclip1 as OutlinedIconPaperclip1,
  IconPause as OutlinedIconPause,
  IconPencil as OutlinedIconPencil,
  IconPencilLine as OutlinedIconPencilLine,
  IconPeople as OutlinedIconPeople,
  IconPeopleCircle as OutlinedIconPeopleCircle,
  IconPeopleGroup2 as OutlinedIconPeopleGroup2,
  IconPeopleIdCard as OutlinedIconPeopleIdCard,
  IconPlay as OutlinedIconPlay,
  IconPlugin1 as OutlinedIconPlugin1,
  IconPlugins as OutlinedIconPlugins,
  IconPlusMedium as OutlinedIconPlusMedium,
  IconPuzzle as OutlinedIconPuzzle,
  IconRacingFlag as OutlinedIconRacingFlag,
  IconServer as OutlinedIconServer,
  IconSettingsGear1 as OutlinedIconSettingsGear1,
  IconSettingsSliderHor as OutlinedIconSettingsSliderHor,
  IconShieldCrossed as OutlinedIconShieldCrossed,
  IconSidebarSimpleLeftWide as OutlinedIconSidebarSimpleLeftWide,
  IconSkip as OutlinedIconSkip,
  IconSquareArrowTopRight as OutlinedIconSquareArrowTopRight,
  IconSquareBehindSquare1 as OutlinedIconSquareBehindSquare1,
  IconSquareCheck as OutlinedIconSquareCheck,
  IconStop as OutlinedIconStop,
  IconStopwatch as OutlinedIconStopwatch,
  IconSuitcaseWork as OutlinedIconSuitcaseWork,
  IconSun as OutlinedIconSun,
  IconTable as OutlinedIconTable,
  IconTag as OutlinedIconTag,
  IconTelephone as OutlinedIconTelephone,
  IconTextSize as OutlinedIconTextSize,
  IconToolbox as OutlinedIconToolbox,
  IconTrashCan as OutlinedIconTrashCan,
  IconTrending3 as OutlinedIconTrending3,
  IconUser as OutlinedIconUser,
  IconUserAdd as OutlinedIconUserAdd,
  IconUserRemove as OutlinedIconUserRemove,
  IconVideo as OutlinedIconVideo,
  IconWhatsapp as OutlinedIconWhatsapp,
} from "@central-icons-react/round-outlined-radius-2-stroke-2";
import {
  IconArrowRotateClockwise as FilledIconArrowRotateClockwise,
  IconBrain2 as FilledIconBrain2,
  IconBubbles as FilledIconBubbles,
  IconCalendarDays as FilledIconCalendarDays,
  IconCallIncoming as FilledIconCallIncoming,
  IconCallOutgoing as FilledIconCallOutgoing,
  IconCamera1 as FilledIconCamera1,
  IconCheckCircle2 as FilledIconCheckCircle2,
  IconCircle as FilledIconCircle,
  IconCirclePlus as FilledIconCirclePlus,
  IconCircleRecord as FilledIconCircleRecord,
  IconCircleX as FilledIconCircleX,
  IconContrast as FilledIconContrast,
  IconEditBig as FilledIconEditBig,
  IconEmail1 as FilledIconEmail1,
  IconEraser as FilledIconEraser,
  IconExclamationCircle as FilledIconExclamationCircle,
  IconExclamationTriangle as FilledIconExclamationTriangle,
  IconEyeOpen as FilledIconEyeOpen,
  IconInboxEmpty as FilledIconInboxEmpty,
  IconLightning as FilledIconLightning,
  IconLinkedin as FilledIconLinkedin,
  IconListAdd as FilledIconListAdd,
  IconPaperPlaneTopRight as FilledIconPaperPlaneTopRight,
  IconPause as FilledIconPause,
  IconPencil as FilledIconPencil,
  IconPlay as FilledIconPlay,
  IconStop as FilledIconStop,
  IconTag as FilledIconTag,
  IconVideo as FilledIconVideo,
} from "@central-icons-react/round-filled-radius-2-stroke-2";

export type IconProps = CentralIconBaseProps;
export type Icon = ComponentType<IconProps>;

// Icons default to 1em so they follow the surrounding text size, like the
// previous icon set did; a size-* class or the size prop still wins.
function em(Base: ComponentType<IconProps & RefAttributes<SVGSVGElement>>) {
  const Sized = forwardRef<SVGSVGElement, IconProps>((props, ref) => (
    <Base size="1em" {...props} ref={ref} />
  ));
  Sized.displayName = Base.displayName;
  return Sized;
}

export const IconAgents = em(OutlinedIconAgents);
export const IconArchive = em(OutlinedIconArchive);
export const IconArrowBoxLeft = em(OutlinedIconArrowBoxLeft);
export const IconArrowCornerDownRight = em(OutlinedIconArrowCornerDownRight);
export const IconArrowDown = em(OutlinedIconArrowDown);
export const IconArrowInbox = em(OutlinedIconArrowInbox);
export const IconArrowLeft = em(OutlinedIconArrowLeft);
export const IconArrowOutOfBox = em(OutlinedIconArrowOutOfBox);
export const IconArrowRight = em(OutlinedIconArrowRight);
export const IconArrowRotateClockwise = em(OutlinedIconArrowRotateClockwise);
export const IconArrowRotateCounterClockwise = em(
  OutlinedIconArrowRotateCounterClockwise,
);
export const IconArrowShareLeft = em(OutlinedIconArrowShareLeft);
export const IconArrowSplitRight = em(OutlinedIconArrowSplitRight);
export const IconArrowUp = em(OutlinedIconArrowUp);
export const IconArrowsHide = em(OutlinedIconArrowsHide);
export const IconArrowsLeftRight = em(OutlinedIconArrowsLeftRight);
export const IconArrowsRepeatRightLeft = em(OutlinedIconArrowsRepeatRightLeft);
export const IconAudio = em(OutlinedIconAudio);
export const IconBarsThree = em(OutlinedIconBarsThree);
export const IconBell = em(OutlinedIconBell);
export const IconBook = em(OutlinedIconBook);
export const IconBrackets2 = em(OutlinedIconBrackets2);
export const IconBrain = em(OutlinedIconBrain);
export const IconBrain2 = em(OutlinedIconBrain2);
export const IconBranch = em(OutlinedIconBranch);
export const IconBrokenChainLink1 = em(OutlinedIconBrokenChainLink1);
export const IconBroom = em(OutlinedIconBroom);
export const IconBubble5 = em(OutlinedIconBubble5);
export const IconBubbleText = em(OutlinedIconBubbleText);
export const IconBubbles = em(OutlinedIconBubbles);
export const IconBuildings = em(OutlinedIconBuildings);
export const IconCalendar1 = em(OutlinedIconCalendar1);
export const IconCall = em(OutlinedIconCall);
export const IconCallCancel = em(OutlinedIconCallCancel);
export const IconCallIncoming = em(OutlinedIconCallIncoming);
export const IconCallOutgoing = em(OutlinedIconCallOutgoing);
export const IconCamera1 = em(OutlinedIconCamera1);
export const IconChainLink1 = em(OutlinedIconChainLink1);
export const IconChart1 = em(OutlinedIconChart1);
export const IconCheckCircle2 = em(OutlinedIconCheckCircle2);
export const IconChecklist = em(OutlinedIconChecklist);
export const IconCheckmark1 = em(OutlinedIconCheckmark1);
export const IconChevronDoubleLeft = em(OutlinedIconChevronDoubleLeft);
export const IconChevronDoubleRight = em(OutlinedIconChevronDoubleRight);
export const IconChevronDownMedium = em(OutlinedIconChevronDownMedium);
export const IconChevronGrabberVertical = em(
  OutlinedIconChevronGrabberVertical,
);
export const IconChevronLeftMedium = em(OutlinedIconChevronLeftMedium);
export const IconChevronRightMedium = em(OutlinedIconChevronRightMedium);
export const IconChevronTopMedium = em(OutlinedIconChevronTopMedium);
export const IconCircle = em(OutlinedIconCircle);
export const IconCircleBanSign = em(OutlinedIconCircleBanSign);
export const IconCircleInfo = em(OutlinedIconCircleInfo);
export const IconCircleRecord = em(OutlinedIconCircleRecord);
export const IconCircleX = em(OutlinedIconCircleX);
export const IconClock = em(OutlinedIconClock);
export const IconCmd = em(OutlinedIconCmd);
export const IconCode = em(OutlinedIconCode);
export const IconCoins = em(OutlinedIconCoins);
export const IconConditionalLogic = em(OutlinedIconConditionalLogic);
export const IconCreditCard1 = em(OutlinedIconCreditCard1);
export const IconCrossMedium = em(OutlinedIconCrossMedium);
export const IconDirection1 = em(OutlinedIconDirection1);
export const IconDotGrid1x3Horizontal = em(OutlinedIconDotGrid1x3Horizontal);
export const IconDotGrid2x3 = em(OutlinedIconDotGrid2x3);
export const IconDotGrid3x3 = em(OutlinedIconDotGrid3x3);
export const IconEditBig = em(OutlinedIconEditBig);
export const IconElectrocardiogram = em(OutlinedIconElectrocardiogram);
export const IconEmail1 = em(OutlinedIconEmail1);
export const IconEmail3 = em(OutlinedIconEmail3);
export const IconExclamationCircle = em(OutlinedIconExclamationCircle);
export const IconExclamationTriangle = em(OutlinedIconExclamationTriangle);
export const IconEyeOpen = em(OutlinedIconEyeOpen);
export const IconEyeSlash = em(OutlinedIconEyeSlash);
export const IconFileText = em(OutlinedIconFileText);
export const IconFilter1 = em(OutlinedIconFilter1);
export const IconFilterAscending = em(OutlinedIconFilterAscending);
export const IconFilterDescending = em(OutlinedIconFilterDescending);
export const IconFlag1 = em(OutlinedIconFlag1);
export const IconFormSquare = em(OutlinedIconFormSquare);
export const IconGlobe = em(OutlinedIconGlobe);
export const IconGoogle = em(OutlinedIconGoogle);
export const IconH1 = em(OutlinedIconH1);
export const IconH2 = em(OutlinedIconH2);
export const IconH3 = em(OutlinedIconH3);
export const IconHashtag = em(OutlinedIconHashtag);
export const IconHeadphones = em(OutlinedIconHeadphones);
export const IconHistory = em(OutlinedIconHistory);
export const IconHourglass = em(OutlinedIconHourglass);
export const IconImages1 = em(OutlinedIconImages1);
export const IconInboxEmpty = em(OutlinedIconInboxEmpty);
export const IconLayersTwo = em(OutlinedIconLayersTwo);
export const IconLightning = em(OutlinedIconLightning);
export const IconLinkedin = em(OutlinedIconLinkedin);
export const IconListAdd = em(OutlinedIconListAdd);
export const IconListBullets = em(OutlinedIconListBullets);
export const IconLoadingCircle = em(OutlinedIconLoadingCircle);
export const IconLock = em(OutlinedIconLock);
export const IconMagnifyingGlass = em(OutlinedIconMagnifyingGlass);
export const IconMapPin = em(OutlinedIconMapPin);
export const IconMegaphone = em(OutlinedIconMegaphone);
export const IconMicrophone = em(OutlinedIconMicrophone);
export const IconMicrophoneOff = em(OutlinedIconMicrophoneOff);
export const IconMinusMedium = em(OutlinedIconMinusMedium);
export const IconMoon = em(OutlinedIconMoon);
export const IconNotepad = em(OutlinedIconNotepad);
export const IconNumberedList = em(OutlinedIconNumberedList);
export const IconOpenQuote1 = em(OutlinedIconOpenQuote1);
export const IconPageEmpty = em(OutlinedIconPageEmpty);
export const IconPaperPlane = em(OutlinedIconPaperPlane);
export const IconPaperPlaneTopRight = em(OutlinedIconPaperPlaneTopRight);
export const IconPaperclip1 = em(OutlinedIconPaperclip1);
export const IconPause = em(OutlinedIconPause);
export const IconPencil = em(OutlinedIconPencil);
export const IconPencilLine = em(OutlinedIconPencilLine);
export const IconPeople = em(OutlinedIconPeople);
export const IconPeopleCircle = em(OutlinedIconPeopleCircle);
export const IconPeopleGroup2 = em(OutlinedIconPeopleGroup2);
export const IconPeopleIdCard = em(OutlinedIconPeopleIdCard);
export const IconPlay = em(OutlinedIconPlay);
export const IconPlugin1 = em(OutlinedIconPlugin1);
export const IconPlugins = em(OutlinedIconPlugins);
export const IconPlusMedium = em(OutlinedIconPlusMedium);
export const IconPuzzle = em(OutlinedIconPuzzle);
export const IconRacingFlag = em(OutlinedIconRacingFlag);
export const IconServer = em(OutlinedIconServer);
export const IconSettingsGear1 = em(OutlinedIconSettingsGear1);
export const IconSettingsSliderHor = em(OutlinedIconSettingsSliderHor);
export const IconShieldCrossed = em(OutlinedIconShieldCrossed);
export const IconSidebarSimpleLeftWide = em(OutlinedIconSidebarSimpleLeftWide);
export const IconSkip = em(OutlinedIconSkip);
export const IconSquareArrowTopRight = em(OutlinedIconSquareArrowTopRight);
export const IconSquareBehindSquare1 = em(OutlinedIconSquareBehindSquare1);
export const IconSquareCheck = em(OutlinedIconSquareCheck);
export const IconStop = em(OutlinedIconStop);
export const IconStopwatch = em(OutlinedIconStopwatch);
export const IconSuitcaseWork = em(OutlinedIconSuitcaseWork);
export const IconSun = em(OutlinedIconSun);
export const IconTable = em(OutlinedIconTable);
export const IconTag = em(OutlinedIconTag);
export const IconTelephone = em(OutlinedIconTelephone);
export const IconTextSize = em(OutlinedIconTextSize);
export const IconToolbox = em(OutlinedIconToolbox);
export const IconTrashCan = em(OutlinedIconTrashCan);
export const IconTrending3 = em(OutlinedIconTrending3);
export const IconUser = em(OutlinedIconUser);
export const IconUserAdd = em(OutlinedIconUserAdd);
export const IconUserRemove = em(OutlinedIconUserRemove);
export const IconVideo = em(OutlinedIconVideo);
export const IconWhatsapp = em(OutlinedIconWhatsapp);

export const IconArrowRotateClockwiseFilled = em(
  FilledIconArrowRotateClockwise,
);
export const IconBrain2Filled = em(FilledIconBrain2);
export const IconBubblesFilled = em(FilledIconBubbles);
export const IconCalendarDaysFilled = em(FilledIconCalendarDays);
export const IconCallIncomingFilled = em(FilledIconCallIncoming);
export const IconCallOutgoingFilled = em(FilledIconCallOutgoing);
export const IconCamera1Filled = em(FilledIconCamera1);
export const IconCheckCircle2Filled = em(FilledIconCheckCircle2);
export const IconCircleFilled = em(FilledIconCircle);
export const IconCirclePlusFilled = em(FilledIconCirclePlus);
export const IconCircleRecordFilled = em(FilledIconCircleRecord);
export const IconCircleXFilled = em(FilledIconCircleX);
export const IconContrastFilled = em(FilledIconContrast);
export const IconEditBigFilled = em(FilledIconEditBig);
export const IconEmail1Filled = em(FilledIconEmail1);
export const IconEraserFilled = em(FilledIconEraser);
export const IconExclamationCircleFilled = em(FilledIconExclamationCircle);
export const IconExclamationTriangleFilled = em(FilledIconExclamationTriangle);
export const IconEyeOpenFilled = em(FilledIconEyeOpen);
export const IconInboxEmptyFilled = em(FilledIconInboxEmpty);
export const IconLightningFilled = em(FilledIconLightning);
export const IconLinkedinFilled = em(FilledIconLinkedin);
export const IconListAddFilled = em(FilledIconListAdd);
export const IconPaperPlaneTopRightFilled = em(FilledIconPaperPlaneTopRight);
export const IconPauseFilled = em(FilledIconPause);
export const IconPencilFilled = em(FilledIconPencil);
export const IconPlayFilled = em(FilledIconPlay);
export const IconStopFilled = em(FilledIconStop);
export const IconTagFilled = em(FilledIconTag);
export const IconVideoFilled = em(FilledIconVideo);
